import { GetAllTemplateFilesApiRequest } from '../../../types/requests/templates/files/get-all-template-files.request';
import { TemplateFileApiModel } from '../../../types/models/template-file.model';
import { client } from './client';
import { DeleteTemplateFileApiRequest } from '../../../types/requests/templates/files/delete-template-file.request';
import { CreateTemplateFileApiRequest } from '../../../types/requests/templates/files/create-template-file.request';

export const getAllTemplateFiles = ({ templateId, ...params }: GetAllTemplateFilesApiRequest) =>
  client.get<TemplateFileApiModel[]>(`/templates/${templateId}/files`, { params });

export const deleteTemplateFile = ({ templateId, fileName }: DeleteTemplateFileApiRequest) =>
  client.delete<void>(`/templates/${templateId}/files/${fileName}`);

export const createTemplateFile = ({ templateId, file }: CreateTemplateFileApiRequest) => {
  const formData = new FormData();
  formData.append('file', file);
  return client.post<void>(`/templates/${templateId}/files`, formData);
};
